// extracted by mini-css-extract-plugin
export default {"root":"PageNotFound_root__eLaFb","back-home":"PageNotFound_back-home__qZzCQ","text":"PageNotFound_text__d7hQg"};